/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationstrustCommerceTrustCommerceIntegration1 from './IntegrationstrustCommerceTrustCommerceIntegration1';

/**
 * The IntegrationsTrustCommerceBody1 model module.
 * @module model/IntegrationsTrustCommerceBody1
 * @version v0.3
 */
export default class IntegrationsTrustCommerceBody1 {
  /**
   * Constructs a new <code>IntegrationsTrustCommerceBody1</code>.
   * @alias module:model/IntegrationsTrustCommerceBody1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsTrustCommerceBody1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsTrustCommerceBody1} obj Optional instance to populate.
   * @return {module:model/IntegrationsTrustCommerceBody1} The populated <code>IntegrationsTrustCommerceBody1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsTrustCommerceBody1();
      if (data.hasOwnProperty('trust_commerce_integration'))
        obj.trustCommerceIntegration = IntegrationstrustCommerceTrustCommerceIntegration1.constructFromObject(data['trust_commerce_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationstrustCommerceTrustCommerceIntegration1} trustCommerceIntegration
 */
IntegrationsTrustCommerceBody1.prototype.trustCommerceIntegration = undefined;

